export const darkGrey = 'rgba(0, 0, 0, 0.54)'
export const lightGrey = 'rgba(229,229,229)'
export const disabledGrey = 'rgba(0, 0, 0, 0.38)'
export const darkLightError = 'rgba(183, 61, 59, 1)'
export const borderGreyColor = 'rgba(185,185,185)'
export const lightError = 'rgba(250, 107, 91, 1)'
export const white = 'rgba(255, 255, 255, 1)'

export const alertDetails = 'rgb(235 220 220)'
